import {valueFormat} from "src/helper/valueFormat";

export const checkDiscount = (discount) => {
  const discountValue = Number(discount).toFixed(2) == 0
    ? `($ ${0.00})` : `($ ${Number(discount).toFixed(2)})`
  return valueFormat(
    discountValue
  )
}
